import ConfirmModal from './ConfirmModal.vue';

export default ConfirmModal;
